export default {
  en: {
    hotelInformation: 'Information',
    code: 'Code',
    address: 'Address',
    email: 'Email',
    tel: 'Tel',
    fax: 'Fax',
    changeInformation: 'Edit Information'
  },
  th: {
    hotelInformation: 'รายละเอียดโรงแรม',
    code: 'โค้ด',
    address: 'ที่อยู่',
    email: 'อีเมล',
    tel: 'โทร.',
    fax: 'แฟกซ์',
    changeInformation: 'แก้ไขรายละเอียด'
  }
}
